import React, {Component} from 'react';
import {Image, UnstyledButton} from "@mantine/core";
import {Berkshire_Swash} from 'next/font/google';
import cx from "clsx";

const berkshireSwash = Berkshire_Swash({
    weight: ['400'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});


interface IProps {
    name?: string;
    url?: string;
    targetBlank?: boolean;
}


const ReadMore: React.FC<IProps> = ( { name, url, targetBlank = true } ) => {
    return (
        <UnstyledButton component="a" href={url} target={targetBlank ? "_blank" : "_parent"}>
            <div className="flex ">
                <div
                    className="rounded-[50px] border border-[#c6dad8] hover:border-[#619b95] group-hover:border-[#619b95] px-[25px] py-[7px] text-[#333] relative group hover:bg-[#99c0bc] group-hover:bg-[#99c0bc] hover:text-white cursor-pointer duration-200">
                    <span
                        className={cx("text-[13px] group-hover:text-[#14554e] font-bold", berkshireSwash.className)}>{name ?? "read more"}</span>
                    <div className="absolute top-[14px] -right-[30px] group-hover:-right-[35px]">
                        <Image
                            h={11}
                            w={50}
                            src="/images/icon_moreArrow.png"
                            alt="Niar Logo"
                        />
                    </div>
                </div>
            </div>
        </UnstyledButton>
    );
}

export default ReadMore;


export const ReadMoreWhite: React.FC<IProps> = ( { name, url, targetBlank = true } ) => {
    return (
        <UnstyledButton component="a" href={url} target={targetBlank ? "_blank" : "_parent"}>
            <div className="flex ">
                <div
                    className="rounded-[50px] border border-[#c6dad8] hover:border-[#619b95] group-hover:border-[#619b95] px-[25px] py-[7px] text-white relative group hover:bg-white hover:text-[#333] cursor-pointer duration-200">
                    <span
                        className={cx("text-[13px] font-bold", berkshireSwash.className)}>{name ?? "read more"}</span>
                    <div className="absolute top-[14px] -right-[30px] group-hover:-right-[35px]">
                        <Image
                            h={11}
                            w={50}
                            src="/images/icon_moreArrow.png"
                            alt="Niar Logo"
                        />
                    </div>
                </div>
            </div>
        </UnstyledButton>
    );
}



export const ReadMoreNoLink: React.FC<IProps> = ( { name } ) => {
    return (
        <div className="flex ">
            <div
                className="rounded-[50px] border border-[#c6dad8] hover:border-[#619b95] group-hover:border-[#619b95] px-[25px] py-[7px] text-[#333] relative group hover:bg-[#99c0bc] group-hover:bg-[#99c0bc] hover:text-white cursor-pointer duration-200">
                <span
                    className={cx("text-[13px] group-hover:text-[#14554e] font-bold", berkshireSwash.className)}>{name ?? "read more"}</span>
                <div className="absolute top-[14px] -right-[30px] group-hover:-right-[35px]">
                    <Image
                        h={11}
                        w={50}
                        src="/images/icon_moreArrow.png"
                        alt="Niar Logo"
                    />
                </div>
            </div>
        </div>
    );
}

// display: block;
// border-radius: 50px;
// font-size: 13px;
// padding: 7px 25px;
// border: #c6dad8 1px solid;
// position: relative;
// width: fit-content;
// letter-spacing: 2px;
// font-weight: normal;
// margin-top: 25px;
// color: #333;
